<template>
  <v-dialog persistent
            @keydown.esc="closeButton"
            @keydown.enter="enterPressed"
            :fullscreen="fullscreen"
            :value="true"
            :content-class="'dialog-wrapper ' + dialogClass"
            @click:outside="$emit('click-outside')"
            :data-qa="dataQa">
    <slot/>
  </v-dialog>
</template>
<script>
  // This component synchronizes the overlay functionality with Frontage
  // and provides the offset so that the dialog is centered within the whole app, not just the iframe
  import {mapGetters} from "vuex";
  export default {
    props: {
      dialogClass: {
        type: String,
        required: false
      },
      fullscreen: {
        type: Boolean,
        required: false,
        default: false
      },
      notifyAngularForView: {
        type: Boolean,
        required: false,
        default: true
      },
      dataQa: {
        type: String,
        required: false,
        default: ''
      }
    },
    created() {
      this.notifyAngularForView && this.$frontageApi.send('open_modal');
      this.$store.commit("increaseDialogIndex")
      this.$store.commit("setDialogStatus", {isOpen:true})

      let that = this;

      this.listener = function (e) {
        if (typeof e.data === "string" && e.data.indexOf("frontage-app") !== -1) {
          const post_data = JSON.parse(e.data);
          if (post_data.message === 'frontageNavAway') {
            that.closeButton()
          }
        }
      };

      window.addEventListener("message", this.listener);
    },
    destroyed() {
      if (this.dialogIndex === 1) {
        window.removeEventListener("message", this.listener);
        this.notifyAngularForView && this.$frontageApi.send('close_modal')
        this.$store.commit("setDialogStatus", {isOpen: false})
      }
      this.$store.commit("decreaseDialogIndex")
    },
    methods: {
      closeButton() {
        this.$emit("closeButtonPressed", false);
      },
      enterPressed() {
        this.$emit("enterPressed");
      }
    },
    computed: {
      ...mapGetters(['dialogIndex']),
    }
  }
</script>

<style lang="scss">
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_mixins.scss";

  .dialog-wrapper {
    /* offset when opened in frontage layout iframe */
    position: relative;
    top: -40px;
    width: auto;
    @include md-and-up {
      @include i-position-mirror(left, -112px);
    }

    @include sm-and-down {
      /* offset when opened in frontage layout iframe */
      top: initial;
      left: initial;
      height: auto !important;
    }

    &.actions-editor-dialog {
      top: -20px;
    }
  }

</style>
